import { FC } from "react";
import { Box, Switch, Typography } from "@mui/material";
import { Control, Controller } from "react-hook-form";

interface SwitchAtivoProps {
  name: string;
  control: Control<any>;
  label?: string;
  disabled?: boolean;
  // Valores gravados no formulário (padrão 1/0, como nos cadastros do HelpDesk)
  valorLigado?: any;
  valorDesligado?: any;
}

// Switch padrão dos formulários (mesmo padrão do XC WMS)
const SwitchAtivo: FC<SwitchAtivoProps> = ({
  name,
  control,
  label = "Ativo",
  disabled = false,
  valorLigado = 1,
  valorDesligado = 0,
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Box sx={{ display: "flex", alignItems: "center", minHeight: 40 }}>
        <Typography variant="body2" sx={{ mr: 1 }}>
          {label}
        </Typography>
        <Switch
          color="warning"
          checked={String(field.value) === String(valorLigado)}
          onChange={(e) =>
            field.onChange(e.target.checked ? valorLigado : valorDesligado)
          }
          onBlur={field.onBlur}
          inputRef={field.ref}
          disabled={disabled}
        />
      </Box>
    )}
  />
);

export default SwitchAtivo;
